
import { MessageCircle, Search, ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

const HowItWorks = () => {
  const { t } = useTranslation('homepage');

  const steps = [
    {
      icon: Search,
      title: t('howItWorks.step1.title'),
      description: t('howItWorks.step1.description'),
      green: false,
    },
    {
      icon: ShieldCheck,
      title: t('howItWorks.step2.title'),
      description: t('howItWorks.step2.description'),
      green: false,
    },
    {
      icon: MessageCircle,
      title: t('howItWorks.step3.title'),
      description: t('howItWorks.step3.description'),
      green: true,
    },
  ];

  return (
    <section className="bg-white py-16 md:py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10 md:mb-12">
          <h2
            className="font-heading text-[length:var(--text-h2)] font-semibold text-brand-ink"
          >
            {t('howItWorks.title')}
          </h2>
          <p className="mx-auto mt-3 max-w-2xl text-[length:var(--text-body)] text-brand-slate">
            {t('howItWorks.description')}
          </p>
        </div>

        <div className="mx-auto grid max-w-5xl grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <div key={index} className="relative rounded-2xl border border-brand-cloud bg-brand-mist/50 p-6 text-center md:p-7">
                {/* Step number */}
                <div className="relative z-10 mb-4 inline-flex h-10 w-10 items-center justify-center rounded-full border-2 border-brand-ink bg-white font-heading text-lg font-bold text-brand-ink">
                  {index + 1}
                </div>
                <div className="mb-3">
                  <Icon
                    className={`h-8 w-8 mx-auto ${step.green ? "text-whatsapp" : "text-brand-slate"}`}
                    strokeWidth={1.75}
                  />
                </div>
                <h3 className="mb-2 font-heading text-[length:var(--text-h3)] font-semibold text-brand-ink">
                  {step.title}
                </h3>
                <p className="text-[length:var(--text-body)] text-brand-slate">
                  {step.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
